export default __webpack_public_path__ + "static/media/BirvoTransparent.dcab4c9f.png";